// extracted by mini-css-extract-plugin
export default {"loginContainer":"Login_loginContainer__F11Fb","loginDiv":"Login_loginDiv__A60UT","formInput":"Login_formInput__SyOBW","version":"Login_version__qMAYA"};